import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedLanguageCountryStep =
  () => import(/* webpackChunkName: "language-country-step.async" */ './language-country-step')
    .then(({ LanguageCountryStepWithI18n }) => LanguageCountryStepWithI18n);

const DelayedLanguageCountryLazyRepository =
  () => import(/* webpackChunkName: "language-country-step.async" */ './language-country-lazy-repository')
    .then(({ LanguageCountryLazyRepositoryWithI18n }) => LanguageCountryLazyRepositoryWithI18n);

export const LanguageCountryStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.LANGUAGE_COUNTRY,
  view: DelayedLanguageCountryStep,
  repository: DelayedLanguageCountryLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
